import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkRestoreClinic, IClinicStore, IClinicActions } from '../types';

const onRestoreClinic: IThunkRestoreClinic = thunk(
  async ({ setClinics }: Actions<IClinicActions>, clinicId, { getState }) => {
    const localState = getState() as IClinicStore;
    await api.clinic.restoreClinic(clinicId);

    const updatedList = localState.list.map(clinic =>
      clinic.id !== clinicId ? clinic : { ...clinic, isArchived: false },
    );

    setClinics({ items: updatedList });
  },
);

export default onRestoreClinic;
